if (!customElements.get('subscription-selector')) {
  customElements.define('subscription-selector', class SubscriptionSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      if (event.target.type !== 'radio') return;

      const form = document.querySelector(this.dataset.formSelector);
      const input = form?.querySelector('[data-hidden-selling-plan-input]');
      if (input) input.value = event.target.value;

      this.querySelectorAll('[data-subscription-card]').forEach((card) => {
        card.classList.toggle('is-selected', card.dataset.value === event.target.value);
      });
    }
  });
}
